// import router from '@/router'
import router from '@/router'
import useUserStore from '@/stores/userStore'
import axios, { type AxiosResponse } from 'axios'
// console.log(import.meta.env.VITE_APP_API)

// 创建axios实例
const service = axios.create({
  // 服务接口请求
  baseURL: import.meta.env.VITE_APP_API as string,
  // 超时设置
  timeout: 15000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' },
})

// 请求拦截
service.interceptors.request.use(
  (config) => {
    const token = useUserStore().token
    // config.headers!['access-token'] = localStorage.getItem('accessToken') as string // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers!.Authorization = token
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        const part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              const params = propName + '[' + key + ']'
              const subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    } else {
      if (config.data && typeof config.data === 'string') {
        config.headers['Content-Type'] = 'plain/text'
      }
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

// 响应拦截器
service.interceptors.response.use(
  (res: AxiosResponse) => {
    if (res.config.responseType === 'arraybuffer') return Promise.resolve(res)
    if (res.config.headers['Content-Type'] === 'multipart/form-data') {
      return Promise.resolve(res.data)
    }
    const code = res.data.code
    if (code === 0) {
      return Promise.resolve(res.data)
    }
    // const msg = errorCodeType(code + '')
    // const message =
    window.$message?.error(res.data.message)
    if (code === 401) {
      // 清除登陆的用户信息数据
      //   跳转到登录页面去
      useUserStore().token = ''
      useUserStore().userInfo = null
      router.push('/login')
    }
    return Promise.reject(res)
  },
  (error) => {
    let { message } = error
    if (message === 'Network Error') {
      message = '后端接口连接异常，请检查网络连接'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时，请检查网络连接'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    }
    window.$message?.error(message)
    return Promise.reject(error)
  },
)

export default service
